import { createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
    name: 'app',
    initialState: {
        online: true
    },
    reducers: {
        online: (state, action) => {
            state.online = true;
        },
        offline: (state, action) => {
            state.online = false;
        }
    }
});

export const online = (dispatch) => {
    dispatch(appSlice.actions.online({}));
}
export const offline = (dispatch) => {
    dispatch(appSlice.actions.offline({}));
}
export const selectOnline = state => state.app.online;

const reducerDetails = { name: appSlice.name, reducer: appSlice.reducer };
export default reducerDetails;